import { useEffect, useRef } from 'react';

/* Same as useEffect except not called on the initial render. */
const useUpdateEffect = (
  fn: () => void,
  dependencies: ReadonlyArray<unknown>,
) => {
  const didMountRef = useRef(false);

  useEffect(() => {
    if (didMountRef.current) fn();
    else didMountRef.current = true;
    // Intentional here - passthrough
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencies);
};

export default useUpdateEffect;
